import { useRouter } from 'next/router';

import { useGlobalConfig } from '../../hooks/configContext';

import { Otovo$Locale } from '../../types/otovoweb';
import { getCanonicalUrl } from './canonicalUrlGenerator';
import { getHeadBaseUrl } from './headContext';

export function useCanonicalUrl() {
  const router = useRouter();
  const locale = router.locale as Otovo$Locale;
  const { asPath } = router;

  const config = useGlobalConfig();

  const baseUrl = getHeadBaseUrl();
  return getCanonicalUrl({
    nextPath: asPath,
    baseUrl,
    market: config.BU_CONFIG.market,
    locale,
    isMultiLocaleBu: config.BU_CONFIG.isMultiLocaleBu,
  });
}
